import { textGrayInvert } from '@osmosis/tailwind-ui/styles/text';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { useIntl } from 'react-intl';

/**
 * Returns Duration component.
 */
export const Duration = ({ duration }: { duration: string }) => {
  const { formatMessage } = useIntl();

  return (
    <Box
      className={`leading-4 p-1 rounded opacity-80 bg-gray-800 text-xs ${textGrayInvert}`}
      aria-label={formatMessage(
        {
          id: 'video.duration',
          defaultMessage: 'Duration: {minutes} minutes and {seconds} seconds',
        },
        { minutes: duration.split(':')[0], seconds: duration.split(':')[1] },
      )}
    >
      {duration}
    </Box>
  );
};
